const DEV = process.env.NODE_ENV === 'development';

import jQuery from 'jquery';

import Rellax from 'rellax';
import emergence from 'emergence.js';
import '../libs/jquery.mousefollower.js';
import Swiper from 'swiper/swiper-bundle.min.js';
import lightGallery from 'lightgallery';
/* import 'lg-zoom';
import 'lg-share' */

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('init common');

    // Remove no-js
    document.documentElement.className = "js";

    // Test touch
    if (!("ontouchstart" in document.documentElement)) {
      document.documentElement.classList.add("no-touch");
    } else {
      document.documentElement.classList.add("touch");
    }

    const loader = document.getElementById('loader')

    function hideLoader(){
      loader.classList.add('hide');
    }

    function showLoader(){
      loader.classList.add('show');
    }

    if( !DEV ) {
      showLoader()
      setTimeout(function(){hideLoader()}, 2000);

      window.addEventListener('load', function(){
        hideLoader();
      });
    }

	var $body,
		$textBgItems,
		lastScrollTop = 0,
		delta = 20;

	jQuery(function ($) {

		$body = $('body');
		$textBgItems = $('.text-bg');

		checkIntroCookie();

		setCursors();
		setPlugins();
		setTextBg();
		bindEvents();
		bindScroll();

		function bindScroll(){
			$(window).scroll(function() {
				var st = $(window).scrollTop();
				if(st < 0){
					st = 0;
				}
				if(lastScrollTop < 0){
					lastScrollTop = 0;
				}
				if(Math.abs(lastScrollTop - st) <= delta)
					return;

				if (st > lastScrollTop){
					$body.addClass("menu--unfixed");
				} else {
					if(st + $(window).height() < $(document).height()) {
						$body.removeClass("menu--unfixed");
					}
				}
				
				lastScrollTop = st;
			});
		}

		function bindEvents(){

			$('a[href^="#"]').on('click', function(e) {
				e.preventDefault();
				var tg = $(this).attr('href');
				var scrollTop = $(tg).position().top;
				$('html, body').animate({ scrollTop });
			})

			$('.js-toggle').bind('click', function(e){
				e.preventDefault();
				var $this = $(this);
				var tg = $this.attr("href") || $this.attr("data-target");
				var name = $this.attr("data-name") || '';
				if(tg){
					$(tg).toggleClass(name);
					$('.js-toggle[data-target="'+tg+'"]').toggleClass('toggled');
					if(name == 'menu--open'){
						window.scrollTo(0, 0);
					}
				}
			})

			$('.links-nav-item').hover(function(){
				$(this).siblings().removeClass('hover');
				$(this).addClass('hover');
			}, function(){
				$(this).siblings().removeClass('hover');
			});

			$('.links-nav').bind("mouseleave", function(){
				$(this).find('.links-nav-item').removeClass('hover');
				$(this).find('.links-nav-item:first-child').addClass('hover');
			});

		}
		
		function setPlugins(){

			//emergence
			if($('.intro.on').length==0){
				emergence.init({
					reset: false,
					elemCushion: 0.5
				});
				emergence.engage();
			}
			
			//parallax
			var rellax = new Rellax('.rellax', {
				center: true,
				breakpoints: [541, 721, 961]
			});

			//gallery img appartamenti
			$('.swiper-gallery').each(function(index){   
				var $swiper = $(this);
				$swiper.attr("id", "swiper"+index);
				
				new Swiper("#swiper"+index, {
					autoplay: {
						delay: 4000,
						disableOnInteraction: false
					},
					speed: 600,
					watchOverflow: true,
					parallax: true,
					pagination: {
						el: '#swiper'+index+' .swiper-pagination',
						clickable: true
					},
				});
			});

			
			var swiperNavs = [];
			//navigazione appartamenti
			$('.swiper-nav').each(function(index){   
				var $swiper = $(this);
				$swiper.attr("id", "swiperNav"+index);
				var length = $swiper.find('.swiper-slide').length,
					visibleSlidesLength = 0,
					$swiperCursor = $swiper.find('.swiper-nav-cursor');
				
				var swiperNav = new Swiper("#swiperNav"+index, {
					watchOverflow: true,
					slidesPerView: 'auto',
					freeMode: true,
					watchSlidesProgress: true,
					watchSlidesVisibility: true,
					breakpoints:{
						768: {
							slidesPerView: length,
						}
					},
					on:{
						afterInit: function(){
							setCursorWidth();
						},						
						resize: function(){
							setCursorWidth();
						} 
					}
				});
				swiperNavs.push(swiperNav);	

				function setCursorWidth(){
					var visibleSlides = $swiper.find('.swiper-slide-visible');
					visibleSlidesLength = $(visibleSlides[0]).outerWidth();
					$swiperCursor.css("width", visibleSlidesLength+"px");
				}
				
			});

			//informazioni appartamenti
			$('.swiper-details').each(function(index){   
				var $swiper = $(this);
				$swiper.attr("id", "swiperDetail"+index);
				
				var swiperItem = new Swiper("#swiperDetail"+index, {
					speed: 600,
					watchOverflow: true,
					parallax: true,
					thumbs: {
						autoScrollOffset: 1,
						swiper: swiperNavs[index]
					},
					on: {
						slideChange: function(swiper){
							var $cursor = $(swiperNavs[index].$el).find('.swiper-nav-cursor');
							var cursorWidth = $cursor.outerWidth();
							$cursor.css({
								"left" : (cursorWidth*swiper.activeIndex)+"px"
							});
							
						}
					}
				});
			
			});
	

			//lightgallery
			$('.js-single-lg').lightGallery({
				selector: 'this'
			});
			$('.js-lg').lightGallery({
				selector: '.js-lg-selector'
			});

		}

		function setTextBg(){
			for(var i = 0; i < $textBgItems.length; i++){
				var $this = $($textBgItems[i]);
				var $width = Math.floor($this.find('.text-bg-inner').outerWidth() + 50);
				var $speed = Math.floor($width*3/160);
				$this.css({
					"--tw": $width + "px",
					"--ts": $speed + 's'
				});
			}
			$(window).resize(function(){
				for(var i = 0; i < $textBgItems.length; i++){
					var $this = $($textBgItems[i]);					
					$this.attr("style", "");
					var $width = Math.floor($this.find('.text-bg-inner').outerWidth() + 50);
					var $speed = Math.floor($width*3/160);
					$this.css({
						"--tw": $width + "px",
						"--ts": $speed + 's'
					});
				}
			})
		}

		function setCursors(){
			$('a[data-cursor]').each(function(index){
				var $this = $(this);
				var $sel = $this.find(".text-cursor");
				$this.mousefollower({
					followerSelector: $($sel)
				});
			});
		}

		

		function introAnimation(){
			$body.addClass('intro--open');
			$body.addClass("animation--start");
			setTimeout(function(){
				$body.addClass("animation--ended");
			}, 3000);
			setTimeout(function(){
				resizeIntro();
			}, 4000);
		}

		function resizeIntro(){
			var target   = $('.intro .wrapper-img'),
				targetImg = $('.intro .wrapper-img img'),
				element = $('#houseImg .wrapper-img'),
				elementImg = $('#houseImg .wrapper-img img'),
				position = element.offset();

			var width = element.outerWidth(),
				height = element.outerHeight(),
				x = position.left, 
				y = position.top,
				styleImg = elementImg.attr("style");
		
			target.css({
				position: 'fixed',
				zIndex: 5000,
				top: y, 
				left: x,
				width: width,
				height: height
			});

			targetImg.attr("style", styleImg);

			setTimeout(function(){
				$('.intro').hide();
				$body.removeClass('intro--open');
				endedAnimation();
			}, 800);
			
		}

		function endedAnimation(){
			if($('body.home').length && $('intro.on').length==0){

				console.log("puppa")
				emergence.init({
					reset: false,
					elemCushion: 0.5
				});
				emergence.engage();
				setTimeout(function(){
					$body.addClass('intro--ended');
				}, 400);
			}else{
				$body.addClass('intro--ended');
			}
			
		}


		function checkIntroCookie() {
			var introOn = $('.intro.on').length;
			if (introOn) {
				introAnimation();
			} else {
				endedAnimation();
			}
		}

	});

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.log('finalize common');
  },
};
